"use client"
import SelectPlacement from "../components/SelectPlacement"

import FightUpIcon from "@/components/icons/FightUpIcon"
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks'
import { flightActions } from '@/lib/redux/features/flight/reduce'
import { FC } from "react"
import { InputSearchRef } from "../components/SelectPlacement/InputSearch"
import { refToAirport } from "./SelectAirportTo"
import { useTranslation } from "react-i18next"

type SelectAirportFromProps = {
  size?: 'small' | 'default',
  layout?: 'default' | 'hero',
  indexInputFlight: number,
  onlyContent?: boolean
}

export const refFromAirport: { current: InputSearchRef | null } = { current: null }

const SelectAirportFrom = ({ size = 'default', layout = 'default', indexInputFlight, onlyContent }: SelectAirportFromProps) => {
  const fromAirport = useAppSelector(state => state.flight.inputFlights[indexInputFlight]?.fromAirport)
  const { t } = useTranslation()
  const searchingFrom = useAppSelector(state => state.flight.searchingFrom)
  const checkedItinerary = useAppSelector(state => state.flight.checkedItinerary)
  const dispatch = useAppDispatch()


  return (

    <SelectPlacement
      onlyContent={onlyContent}
      layout={layout}
      getRefInput={(curr) => { refFromAirport.current = curr; }}
      size={size}
      value={fromAirport}
      label={t("flight.from")}
      icon={<FightUpIcon />}
      placeholder={t("flight.from_placeholder")}
      searching={searchingFrom}
      onChange={(airport) => {
        dispatch(flightActions.selectFromAirport({ indexInputFlight, fromAirport: airport }))
        if (!airport) return
        if (checkedItinerary) {
          dispatch(flightActions.selectToAirport({ indexInputFlight: 1, toAirport: airport }))
        }
        refToAirport.current?.focus()
      }}
      chooseCurrentLy={(from, to) => {
        dispatch(flightActions.selectToAirport({ indexInputFlight, toAirport: to }))
        dispatch(flightActions.selectFromAirport({ indexInputFlight, fromAirport: from }))
      }}

      onSearch={(val) => {
        if (val) {
          if (!searchingFrom) {
            dispatch(flightActions.updateSearchingFrom(true))
          }
        } else {
          if (searchingFrom) {
            dispatch(flightActions.updateSearchingFrom(false))
          }
        }
      }}
    />
  )
}

export default SelectAirportFrom